








import { Component, Prop, Vue } from 'vue-property-decorator';
import SpItem from './sp-item.vue';
import DiscoverMore from './discover-more.vue';
import { FavoritesSpInfo } from '../api/index';

@Component({
  components: {
    SpItem,
    DiscoverMore,
  },
})
export default class SpList extends Vue {
  @Prop() spList!: FavoritesSpInfo[];
  get showDiscoverMore() {
    return this.spList.length <= 4;
  }
}
